import * as React from 'react';

import { BaseRow } from '../../types';
import { ColumnsContextState } from '../ColumnControlsContext/ColumnControlsContext';

const fallbackCallback = () => console.error('No ColumnsContext exists');

export const ColumnsContext = React.createContext<ColumnsContextState<BaseRow>>({
  columns: [],
  getColumn: () => {
    fallbackCallback();
    return undefined;
  },
  setColumns: fallbackCallback,
  addColumn: fallbackCallback,
});

export default ColumnsContext;
